/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Transcript_FoundInputs */

const en_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Transcript Found`)
};

const fr_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune transcription trouvée`)
};

const de_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Transkript gefunden`)
};

const it_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna trascrizione trovata`)
};

const ru_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст расшифровки не найден`)
};

const es_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró ninguna transcripción`)
};

const zh_cn2_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到文字记录`)
};

const ja_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトが見つかりません`)
};

const hi_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रतिलेख नहीं मिला`)
};

const pt_pt2_no_transcript_found = /** @type {(inputs: No_Transcript_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma transcrição encontrada`)
};

/**
* | output |
* | --- |
* | "No Transcript Found" |
*
* @param {No_Transcript_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_transcript_found = /** @type {((inputs?: No_Transcript_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Transcript_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_transcript_found(inputs)
	if (locale === "de") return de_no_transcript_found(inputs)
	if (locale === "it") return it_no_transcript_found(inputs)
	if (locale === "ru") return ru_no_transcript_found(inputs)
	if (locale === "es") return es_no_transcript_found(inputs)
	if (locale === "zh-CN") return zh_cn2_no_transcript_found(inputs)
	if (locale === "ja") return ja_no_transcript_found(inputs)
	if (locale === "hi") return hi_no_transcript_found(inputs)
	if (locale === "pt-PT") return pt_pt2_no_transcript_found(inputs)
	return en_no_transcript_found(inputs)
});